import axios from "axios";

export const TOKEN_KEY = "ocw_token";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  return d?.msg || String(d);
}

export function downloadBlob(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const fmtNum = (n) => new Intl.NumberFormat("id-ID").format(n ?? 0);
export const fmtRp = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n ?? 0);
export const COMPANY = {
  name: "PT Cahaya Fish Bali", tagline: "Cold Storage Ikan Laut", address: "Bali, Indonesia", logo: "/logo-icon.png", logoFull: "/logo-cahaya-fish.png",
  banks: [{ bank: "BCA", account_no: "2360887777", holder: "PT Cahaya Fish Bali" }, { bank: "BRI", account_no: "012501001598569", holder: "PT Cahaya Fish Bali" }],
};
export const fmtDate = (s) =>
  s ? new Date(s + (s.length === 10 ? "T00:00:00" : "")).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) : "-";
export const todayISO = () => new Date().toISOString().slice(0, 10);
